import {
  ROLE_FETCH_REQUEST_FAILURE,
  ROLE_FETCH_REQUEST,
  ROLE_FETCH_REQUEST_SUCCESS,
  ROLE_ADD_REQUEST,
  ROLE_ADD_REQUEST_SUCCESS,
  ROLE_ADD_REQUEST_FAILURE,
  ROLE_UPDATE_REQUEST,
  ROLE_UPDATE_REQUEST_SUCCESS,
  ROLE_UPDATE_REQUEST_FAILURE,
  ROLE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const rolesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case ROLE_FETCH_REQUEST:
    case ROLE_ADD_REQUEST:
    case ROLE_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case ROLE_ADD_REQUEST_SUCCESS:
    case ROLE_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case ROLE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case ROLE_FETCH_REQUEST_FAILURE:
    case ROLE_ADD_REQUEST_FAILURE:
    case ROLE_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case ROLE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default rolesReducer;
